import React from "react";
import { Link } from "react-router-dom";
import app1 from "../images/Icons/app1.png";
import app2 from "../images/Icons/app2.png";
import truck from "../images/Icons/truck.png";
import support from "../images/Icons/customer.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchHowTo } from "../redux/slice/howTo";
import { useEffect } from "react";

export default function FooterBanner() {
  const dispatch = useDispatch();
  const { howToData, isError } = useSelector((state) => state.howTo);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchHowTo());
    }
  }, [dispatch, isError]);

  return (
    <>
      <div className="container-fluid">
        <div className="showcase-product mrty1">
          <div className="row g-2">
            <div className="col-lg-6 px-2">
              <div className="accolates-content">
                <h4>{howToData.title}</h4>
                <div
                  dangerouslySetInnerHTML={{ __html: howToData.description }}
                />
              </div>
            </div>
            <div className="col-lg-6 px-2">
              {howToData.video_link ? (
                <iframe
                  className="w-100 rounded-3"
                  src={`${howToData.video_link}?autoplay=0&rel=0`}
                  allowFullScreen
                  style={{ aspectRatio: 16 / 9 }}
                  title="Biznie shopping video"
                ></iframe>
              ) : (
                <p className="m-0 text-center">No video available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="app-dwn-bnr">
        <div className="dwnlod-p4">
          <h4>Download biznie available on google play & app store!!</h4>
          <h6 className="mobl-h6">Download biznie app</h6>
          <div className="dwnlod-p4-item">
            <Link to="/">
              <img src={app1} alt="app" />
            </Link>
            <Link to="/">
              <img src={app2} alt="app" />
            </Link>
          </div>
        </div>
      </div>
      <div className="icon-boxes-container">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="icon-box icon-box-side">
                <div className="icon-box-icon text-dark">
                  <img src={truck} alt="delivery" />
                </div>
                <div className="icon-box-content">
                  <h3 className="icon-box-title">On time delivery</h3>
                  <p>Minimum order quantity</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="icon-box icon-box-side">
                <div className="icon-box-icon me-4">
                  <span>20+</span>
                </div>

                <div className="icon-box-content ms-4">
                  <h3 className="icon-box-title">Products available</h3>
                  <p>Through biznie app</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="icon-box icon-box-side">
                <div className="icon-box-icon">
                  <span>7+</span>
                </div>

                <div className="icon-box-content">
                  <h3 className="icon-box-title">Years of experience</h3>
                  <p>Decades of expertise</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="icon-box icon-box-side">
                <div className="icon-box-icon text-dark">
                  <img src={support} alt="delivery" />
                </div>

                <div className="icon-box-content">
                  <h3 className="icon-box-title">We Support</h3>
                  <p>24/7 amazing services</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
